import React, { useEffect, useState } from 'react';
import { Typography, Grid, TextField, Box, Select, FormControl, MenuItem, InputLabel, Snackbar, Alert, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ControlledFormDataGrid from "../../../components/DataGrid/ControlledFormDataGrid";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import axios from 'axios'
import { APIURL } from '../../../config';
import dayjs from 'dayjs';
import { convertTime } from 'src/utils/time';

export default function FormReport(props) {
    const apiRef = useGridApiRef();

    const [Form_Reports, setForm_Reports] = useState([]);
    const [currReport, setCurrReport] = useState(null);
    const [reportID, setReportID] = useState('');
    const [reportFormID, setReportFormID] = useState('');
    const [reportName, setReportName] = useState('');
    const [custList, setCustList] = useState([]);
    const [custID, setCustID] = useState('');
    const [custName, setCustName] = useState('');
    const [empList, setEmpList] = useState([]);
    const [empID, setEmpID] = useState('');
    const [empName, setEmpName] = useState('');
    const [taskTypeList, setTaskTypeList] = useState([]);
    const [taskType, setTaskType] = useState('');
    const [formStartDate, setFormStartDate] = useState(null);
    const [formEndDate, setFormEndDate] = useState(null);
    const [taskStartDate, setTaskStartDate] = useState(moment().startOf('month'));
    const [taskEndDate, setTaskEndDate] = useState(moment().endOf('month'));
    const [formData, setFormData] = useState([]);
    const [formColumns, setFormColumns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState(null);

    const handleCloseSnackbar = () => setSnackbar(null);

    useEffect(() => {
        const fetchReportData = async () => {
            try {
                const Form_Reports = await axios.get(APIURL + '/forms/form_report', { params: { report_company_id: props.comp_id } });
                const associatedCustomers = await axios.get(APIURL + '/customers/v2/associated', { params: { company_id: props.comp_id, employee_id: props.user.emp_id, type: props.user.permissions.AdminLevelCustomers ? 'Admin' : 'Manager' } });
                const employees = await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: props.comp_id } });
                const taskTypes = await axios.get(APIURL + '/dropdowns/dropdownType/taskTypeList', { params: { comp_id: props.comp_id } });
                setForm_Reports(Form_Reports.data);
                setCustList(associatedCustomers.data.filter((cus) => cus.cus_status === 'Active'));
                setEmpList(employees.data);
                setTaskTypeList(taskTypes.data.filter((taskType) => [0, 3].includes(taskType.is_Active)));
                setLoading(false);
            } catch (error) {
                console.error('Error fetching form report data:', error);
            }
        };
        fetchReportData();
    }, []);

    const handleReportChange = (event) => {
        setFormData([]);
        setReportName(event.target.value);
    };

    const handleReportMenuItemClick = (event) => {
        const currReport = Form_Reports.filter((report) => report.report_id === parseInt(event.target.id))[0];

        setReportID(event.target.id);
        setReportFormID(currReport?.report_form_id);
        setCurrReport(currReport);
    }

    const handleCustChange = (event) => {
        setFormData([]);
        setCustName(event.target.value);
    };

    const handleCustMenuItemClick = (event) => {
        setCustID(event.target.id);
    }

    const handleEmpChange = (event) => {
        setFormData([]);
        setEmpName(event.target.value);
    };

    const handleEmpMenuItemClick = (event) => {
        setEmpID(event.target.id);
    }

    const handleTaskTypeChange = (event) => {
        setFormData([]);
        setTaskType(event.target.value);
    };

    const onSearch = async () => {
        if (!reportID) {
            setSnackbar({
                children: "Please select a Form from the dropdown!",
                severity: "error",
            });
            return;
        }

        try {
            const formsWithData = await axios.get(APIURL + '/customer_form/formsWithData/' + 0, {
                params: {
                    compID: props.comp_id,
                    formID: reportFormID,
                    custID: custID,
                    empID: empID,
                    taskType: taskType,
                    formStartDate: formStartDate ? moment(formStartDate).format('MM/DD/YYYY') : null,
                    formEndDate: formEndDate ? moment(formEndDate).format('MM/DD/YYYY') : null,
                    taskStartDate: taskStartDate ? moment(taskStartDate).format('MM/DD/YYYY') : null,
                    taskEndDate: taskEndDate ? moment(taskEndDate).format('MM/DD/YYYY') : null
                }
            });

            if (formsWithData.data.length === 0) {
                setSnackbar({
                    children: "No data available!",
                    severity: "error",
                });
                return;
            }

            let formComponents;
            let rows = formsWithData.data.map((data, idx) => {
                formComponents = data?.translated_json_schema ? data?.translated_json_schema.components : data.json_schema.components;

                let formRows = {
                    id: idx,
                    cus_name: data.cus_name,
                    cus_local_id: data.cus_local_id || '-',
                    emp_name: data.emp_first_name ? data.emp_first_name + ' ' + data.emp_last_name : '-',
                    emp_local_id: data.emp_local_id || '-',
                    tas_title: data.tas_title,
                    tas_type: data.tas_type || '-',
                    tas_start_time: convertTime(data.empLocdate, data.empLocate_timezone, moment.tz.guess(), "MM/DD/YYYY hh:mm A") ?? moment(data.empLocdate).utc().format('MM/DD/YYYY hh:mm A'),
                    tas_end_time: convertTime(data.checkoutEmpDate, data.empLocate_timezone, moment.tz.guess(), "MM/DD/YYYY hh:mm A") ?? moment(data.checkoutEmpDate).utc().format('MM/DD/YYYY hh:mm A'),
                    tas_loc: data.locInfo?.[0] ? data.locInfo[0].loc_addr_line1 + ', ' + data.locInfo[0].loc_addr_line2 + ', ' + data.locInfo[0].loc_city + ', ' + data.locInfo[0].loc_state + ' ' + data.locInfo[0].loc_zip : '-',
                    ...data.formData.data
                }
                return formRows;
            });

            // Case: If Select Boxes component is used from Form Builder
            rows = rows.map(row => {
                for (let key in row) {
                    if (typeof row[key] === 'object' && row[key] !== null) {
                        row[key] = Object.keys(row[key])
                            .filter(k => row[key][k])
                            .join(', ');
                    }
                }
                return row;
            });

            let columns = [
                { field: "id", headerName: "ID", hide: true },
                { field: "cus_name", headerName: "Customer Name", width: 150 },
                { field: "cus_local_id", headerName: "Local Customer ID", width: 150 },
                { field: "emp_name", headerName: "Employee Name", width: 150 },
                { field: "emp_local_id", headerName: "Local Employee ID", width: 150 },
                { field: "tas_title", headerName: "Task Title", width: 200 },
                { field: "tas_type", headerName: "Task Type", width: 150 },
                { field: "tas_start_time", headerName: "Task Start Date", width: 150, },
                { field: "tas_end_time", headerName: "Task End Date", width: 150, },
                { field: "tas_loc", headerName: "Task Location", width: 200, wrap: true },
            ];

            if (formComponents) {
                formComponents.forEach((component) => {
                    if (component.key !== 'submit' && component.input) {
                        columns.push({ field: component.key, headerName: component.label });
                    }
                })
            }

            setFormColumns(columns);
            setFormData(rows);
        } catch (error) {
            setSnackbar({
                children: error.message,
                severity: "error"
            });
        }
    }

    return (
        <div style={{ width: '100%' }}>
            <div>
                {!!loading && (
                    <div className="d-flex flex-row w-100 justify-content-center mt-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                )}
                {!loading &&
                    <div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 0', marginBottom: 20 }}>
                            <div style={{ marginRight: 10 }}>
                                <FormControl sx={{ minWidth: 200 }} size="small">
                                    <InputLabel id="employeeSelectLabel">Select Report *</InputLabel>
                                    <Select
                                        labelId="reportSelectLabel"
                                        id="reportSelect"
                                        value={reportName}
                                        label="Select Report"
                                        onChange={handleReportChange}
                                    >
                                        {Form_Reports.map((report) => (
                                            <MenuItem
                                                id={report.report_id}
                                                key={report.report_id}
                                                value={report.report_name}
                                                onClick={handleReportMenuItemClick}
                                            >
                                                {report.report_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ marginRight: 10 }}>
                                <FormControl sx={{ minWidth: 200 }} size="small">
                                    <InputLabel id="employeeSelectLabel">Select Customer</InputLabel>
                                    <Select
                                        labelId="custSelectLabel"
                                        id="custSelect"
                                        value={custName}
                                        label="Select Customer"
                                        onChange={handleCustChange}
                                    >
                                        {custList.map((cust) => (
                                            <MenuItem
                                                id={cust.cus_id}
                                                key={cust.cus_id}
                                                value={cust.cus_name}
                                                onClick={handleCustMenuItemClick}
                                            >
                                                {cust.cus_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ marginRight: 10 }}>
                                <FormControl sx={{ minWidth: 200 }} size="small">
                                    <InputLabel id="employeeSelectLabel">Select Employee</InputLabel>
                                    <Select
                                        labelId="empSelectLabel"
                                        id="empSelect"
                                        value={empName}
                                        label="Select Employee"
                                        onChange={handleEmpChange}
                                    >
                                        {empList.map((emp) => (
                                            <MenuItem
                                                id={emp.id}
                                                key={emp.id}
                                                value={emp.employee_name}
                                                onClick={handleEmpMenuItemClick}
                                            >
                                                {emp.employee_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ marginRight: 10 }}>
                                <FormControl sx={{ minWidth: 200 }} size="small">
                                    <InputLabel id="taskTypeSelectLabel">Select Task Type</InputLabel>
                                    <Select
                                        labelId="tTypeSelectLabel"
                                        id="tTypeSelect"
                                        value={taskType}
                                        label="Select Task Type"
                                        onChange={handleTaskTypeChange}
                                    >
                                        {taskTypeList.map((type) => (
                                            <MenuItem
                                                id={type.ddID}
                                                key={type.ddID}
                                                value={type.EntityValue}
                                            >
                                                {type.EntityValue}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <Grid style={{ display: 'flex' }}>
                                <Grid size={6} style={{ marginRight: 10 }}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        localeText={{ start: "From Date", end: "To Date" }}
                                    >
                                        <DateRangePicker
                                            label='Form Date Range'
                                            value={[
                                                formStartDate ? dayjs(formStartDate) : null,
                                                formEndDate ? dayjs(formEndDate) : null,
                                            ]}
                                            onChange={(newValue) => {
                                                setFormStartDate(newValue[0] ? new Date(newValue[0]) : null);
                                                setFormEndDate(newValue[1] ? new Date(newValue[1]) : null);
                                                setFormData([]); // assuming this exists in your component
                                            }}
                                            slotProps={{ fieldSeparator: { children: 'to' }, textField: { size: 'small' } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={6}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        localeText={{ start: "From Date", end: "To Date" }}
                                    >
                                        <DateRangePicker
                                            label='Task Date Range'
                                            value={[
                                                taskStartDate ? dayjs(taskStartDate) : null,
                                                taskEndDate ? dayjs(taskEndDate) : null,
                                            ]}
                                            onChange={(newValue) => {
                                                setTaskStartDate(newValue[0] ? new Date(newValue[0]) : null);
                                                setTaskEndDate(newValue[1] ? new Date(newValue[1]) : null);
                                                setFormData([]); // assuming this exists in your component
                                            }}
                                            slotProps={{ fieldSeparator: { children: 'to' }, textField: { size: 'small' } }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid style={{ marginLeft: 10 }} size={1}>
                                    <Button
                                        onClick={() => { onSearch(); }}
                                        variant="contained"
                                    >
                                        SEARCH
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                        {formData.length !== 0 &&
                            <ControlledFormDataGrid
                                reportID={reportID}
                                reportHeader={currReport?.report_header}
                                reportSubheader1={currReport?.report_subheader1}
                                reportSubheader2={currReport?.report_subheader2}
                                user={props.user}
                                apiRef={apiRef}
                                getRowId={(row) => row.id}
                                rows={formData}
                                columns={formColumns}
                                checkboxSelection={false}
                                disableRowSelectionOnClick
                            />
                        }
                        {!!snackbar && (
                            <Snackbar
                                open
                                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                onClose={handleCloseSnackbar}
                                autoHideDuration={6000}
                            >
                                <Alert {...snackbar} onClose={handleCloseSnackbar} />
                            </Snackbar>
                        )}
                    </div>
                }
            </div>
        </div>
    )
};